import { BeautyProfile } from "core/glambox/endpoints/BeautyProfile";
import { Coupon } from "core/glambox/endpoints/Coupon";
import { Edition } from "core/glambox/endpoints/Edition";
import { Feedback } from "core/glambox/endpoints/Feedback";
import { GlamClub } from "core/glambox/endpoints/GlamClub";
import { GlamMag } from "core/glambox/endpoints/GlamMag";
import { Logistics } from "core/glambox/endpoints/Logistics";
import { Open } from "core/glambox/endpoints/Open";
import { Partner } from "core/glambox/endpoints/Partner";
import { Person } from "core/glambox/endpoints/Person";
import { ProcessExecution } from "core/glambox/endpoints/ProcessExecution";
import { Product } from "core/glambox/endpoints/Product";
import { ShippingOrder } from "core/glambox/endpoints/ShippingOrder";
import { Subscriber } from "core/glambox/endpoints/Subscriber";
import { Token } from "core/glambox/endpoints/Token";
import { Voucher } from "core/glambox/endpoints/Voucher";
import { HandleFile } from "core/glambox/endpoints/HandleFile";
import { InfluencerReport } from "core/glambox/endpoints/InfluencerReport";
import { InfluencerDocument } from "core/glambox/endpoints/InfluencerDocument";
import { Campaign } from "core/glambox/endpoints/Campaign";
import { Glamshop } from "core/glambox/endpoints/Glamshop";
import { GlampartnerPaymentRegistry } from "core/glambox/endpoints/GlampartnerPaymentRegistry";

/**
 * core/glambox/GlamboxEndpoints
 * ----------------------------------------------------------------------
 * Expõe os endpoints disponíveis para acesso na API da Glambox.
 * 
 * Comente/descomente o recurso desejado, de acordo com o projeto, para que 
 * endpoints desnecessários não sejam compilados.
 * 
 * @since     0.0.1
 */
export const GlamboxEndpoints = {
  BeautyProfile, 
  Coupon, 
  Edition, 
  Feedback, 
  GlamClub, 
  GlamMag, 
  Logistics, 
  Open, 
  Partner, 
  Person, 
  ProcessExecution, 
  Product, 
  ShippingOrder, 
  Subscriber, 
  Token, 
  Voucher,
  HandleFile,
  InfluencerReport,
  InfluencerDocument,
  Campaign,
  Glamshop,
  GlampartnerPaymentRegistry
};
